import { Modal, message } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PurchaseModalRender from './children/PurchaseModalRender';
import purchaseList from '../../../../constants/purchase';
import actions from '../../../../redux/action';
import {
  requsetGetPurchase,
  requsetGetSubscription,
} from '../../../../api/apis';
import i18n from '../../../../../../locales/i18n';
import Utils from '../../../../../../utils/utils';
import cartUrl from '@/views/account/utils/cartUrl';
class PurchaseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPackageKey: 'monthly',
      packageMap: purchaseList,
      enterCodeInputVisible: false,
      visible: false,
      purchaseLoading: false,
    };
    this.timer = null;
    this.urlParam = {};
  }

  componentDidMount() {
    // eslint-disable-next-line no-restricted-globals
    if (location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = this.getUrlParam(location.href);
      this.urlParam = urlParam;
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      this.urlParam = obj;
    }
    // eslint-disable-next-line no-restricted-globals
    // const urlParam = this.getUrlParam(location.href);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  /**
   * 控制当前套餐
   * @param {Boolean} checked 控制当前套餐
   */
  handleEnterCodeInputVisibleChange = (enterCodeInputVisible) => {
    this.setState({
      enterCodeInputVisible,
    });
  };

  /**
   * 控制当前套餐
   * @param {Boolean} checked 控制当前套餐
   */
  handleCurrPackageKeyChange = (checked) => {
    let currPackageKey = checked ? 'yearly' : 'monthly';
    this.setState({
      currPackageKey,
      currPackage: this.state.packageMap.get(currPackageKey),
    });
  };

  /**
   * 轮询订阅信息
   */
  handleListenerSubscription = () => {
    this.timer = setInterval(() => {
      requsetGetSubscription()
        .then((res) => {
          if (res.code === 200) {
            if (res.data.subscription != null) {
              let result = res.data.subscription.filter((item) => {
                return item.product_name == 'HitPaw Online';
              });
              if (result.length > 0) {
                if (result[0].status != 'Expired') {
                  console.log('监听到了用户已经购买');
                  this.props.onPurchaseModalObjChange({
                    ...this.props.purchaseModalObj,
                    visible: false,
                  });
                }
              }
            }
            this.props.onSubscriptionChange(res.data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 12000);
  };

  /**
   * 请求购买链接
   */
  handleGetPurchase = () => {
    this.setState({
      purchaseLoading: true,
    });
    const { currPackageKey } = this.state;
    let site = Utils.getLanguage();
    let plan = currPackageKey === 'monthly' ? 'month' : 'year';

    const formData = new FormData();
    formData.append('plan', plan);
    formData.append('site', site);
    requsetGetPurchase({
      body: formData,
    })
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          //轮询监听用户购买
          this.handleListenerSubscription();
          //购物车地址
          let cycle = '';
          if (plan === 'month') {
            cycle = `2`;
          } else if (plan === 'year') {
            cycle = `3`;
          } else {
            cycle = `1`;
          }
          // const track = cartUrl('');
          // track.cycle = cycle;
          // let __s = Object.keys(track)
          //   .map((v) => {
          //     return `track[${v}]=${track[v]}`;
          //   })
          //   .join('&');

          // let cartUrlParam = res.data.cart_url;
          // cartUrlParam = cartUrlParam + '&' + __s;
          // //购物车地址

          // window.open(cartUrlParam, '_blank');

          let cartUrl = res.data.cart_url;
          cartUrl =
            cartUrl +
            `&track[type]=${this.urlParam['track[type]']}&track[sid]=${this.urlParam['track[sid]']}&track[func]=${this.urlParam['track[func]']}&track[reason]=${this.urlParam['track[reason]']}&track[host]=${this.urlParam['track[host]']}&track[platform]=${this.urlParam['track[platform]']}&track[cycle]=${cycle}&track[ab]=${this.urlParam['track[ab]']}&track[channel]=${this.urlParam['track[channel]']}&track[discount]=${this.urlParam['track[discount]']}`;
          window.open(cartUrl, '_blank');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          purchaseLoading: false,
        });
      });
  };

  handleSentCode = (e) => {
    e.stopPropagation();
    message.warn(i18n.t('purchase:promoCodeInvalidTips'));
  };

  render() {
    const { visible, handleVisible } = this.props;
    return (
      <Modal
        className='purchaseModal'
        centered
        visible={visible}
        title={null}
        footer={null}
        getContainer={false}
        width={684}
        onCancel={() => handleVisible(false)}
      >
        <PurchaseModalRender
          currPackageKey={this.state.currPackageKey}
          enterCodeInputVisible={this.state.enterCodeInputVisible}
          currPackage={
            this.state.currPackage
              ? this.state.currPackage
              : this.state.packageMap.get(this.state.currPackageKey)
          }
          handleCurrPackageKeyChange={this.handleCurrPackageKeyChange}
          handleEnterCodeInputVisibleChange={
            this.handleEnterCodeInputVisibleChange
          }
          signUpUrl={this.state.signUpUrl}
          purchaseType={!this.props.profileObj ? 'account' : 'cartUrl'}
          handleGetPurchase={this.handleGetPurchase}
          purchaseLoading={this.state.purchaseLoading}
          handleSentCode={this.handleSentCode}
        />
      </Modal>
    );
  }
}

const mapStateToPropos = (state) => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
});
const mapDispatchToProps = (dispatch) => ({
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(PurchaseModal);
